var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-report-wrap"
  }, [_c('div', {
    staticClass: "report-musk",
    on: {
      "click": function click($event) {
        return _vm.hideReport();
      }
    }
  }), _vm._v(" "), !_vm.reportState ? _c('div', {
    staticClass: "card-report"
  }, [_c('a', {
    staticClass: "report-item",
    attrs: {
      "href": "javascript:void(0);",
      "title": _vm.$t('liveroom.personalCard.reportContent1')
    },
    on: {
      "click": function click($event) {
        return _vm.changeState(1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.personalCard.reportContent1')))]), _vm._v(" "), _c('a', {
    staticClass: "report-item",
    attrs: {
      "href": "javascript:void(0);",
      "title": _vm.$t('liveroom.personalCard.reportContent2')
    },
    on: {
      "click": function click($event) {
        return _vm.changeState(2);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.personalCard.reportContent2')))]), _vm._v(" "), _c('a', {
    staticClass: "report-item",
    attrs: {
      "href": "javascript:void(0);",
      "title": _vm.$t('liveroom.personalCard.reportContent3')
    },
    on: {
      "click": function click($event) {
        return _vm.changeState(3);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.personalCard.reportContent3')))]), _vm._v(" "), _c('a', {
    staticClass: "report-item",
    attrs: {
      "href": "javascript:void(0);",
      "title": _vm.$t('liveroom.personalCard.reportContent4')
    },
    on: {
      "click": function click($event) {
        return _vm.changeState(4);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.personalCard.reportContent4')))]), _vm._v(" "), _c('a', {
    staticClass: "report-item",
    attrs: {
      "href": "javascript:void(0);",
      "title": _vm.$t('liveroom.personalCard.reportContent5')
    },
    on: {
      "click": function click($event) {
        return _vm.changeState(5);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.personalCard.reportContent5')))]), _vm._v(" "), _c('a', {
    staticClass: "report-item",
    attrs: {
      "href": "javascript:void(0);",
      "title": _vm.$t('liveroom.personalCard.reportContent6')
    },
    on: {
      "click": function click($event) {
        return _vm.changeState(6);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.personalCard.reportContent6')))]), _vm._v(" "), _c('a', {
    staticClass: "report-item",
    attrs: {
      "href": "javascript:void(0);",
      "title": _vm.$t('liveroom.personalCard.reportContent7')
    },
    on: {
      "click": function click($event) {
        return _vm.changeState(7);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.personalCard.reportContent7')))]), _vm._v(" "), _c('a', {
    staticClass: "report-item",
    attrs: {
      "href": "javascript:void(0);",
      "title": _vm.$t('liveroom.personalCard.reportContent8')
    },
    on: {
      "click": function click($event) {
        return _vm.changeState(8);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.personalCard.reportContent8')))]), _vm._v(" "), _c('a', {
    staticClass: "report-item",
    attrs: {
      "href": "javascript:void(0);",
      "title": _vm.$t('liveroom.personalCard.reportContent9')
    },
    on: {
      "click": function click($event) {
        return _vm.changeState(9);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.personalCard.reportContent9')))])]) : _c('card-report-desc', {
    attrs: {
      "userInfo": _vm.userInfo,
      "reportState": _vm.reportState
    },
    on: {
      "closeReport": _vm.closeReport,
      "feedbackSend": _vm.feedbackSend
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };